import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';

import { OfferPreviewSettings } from 'models/offer-preview-settings';
import { StoreService } from 'shared/services/store.service';
import { PricingService } from 'shared/services/pricing.service';

import { OfferPreviewSettingsComponent } from '../offer-preview-settings/offer-preview-settings.component';

@Component({
  selector: 'app-offer-preview-settings-modal',
  templateUrl: './offer-preview-settings-modal.component.html',
  styleUrls: ['./offer-preview-settings-modal.component.scss']
})
export class OfferPreviewSettingsModalComponent {
  @ViewChild(OfferPreviewSettingsComponent) offerPreviewSettingsComponent!: OfferPreviewSettingsComponent;

  // needed for multimodal form.statusChange subscription
  get form(): UntypedFormGroup {
    return this.offerPreviewSettingsComponent.form;
  }

  get previewSettings(): OfferPreviewSettings {
    return this.offerPreviewSettingsComponent.offerPreviewSettings;
  }

  get pdfSrc(): string {
    return this.offerPreviewSettingsComponent.pdfSrc;
  }

  constructor(
    private pricingService: PricingService,
    private storeService: StoreService
  ) { }

  onSubmit(): Observable<any> {
    this.storeService.setOfferPreview({ ...this.previewSettings, pdfSrc: this.pdfSrc });

    return of({});
  }

  onClose(): void {
    // check and disable pricing calculation
    // base on branch settings
    const component = this.offerPreviewSettingsComponent;
    const disablePriceCalculation = component.disablePriceCalculation;

    if (disablePriceCalculation) {
      this.storeService.getCurrentOfferPricingState().subscribe((data) => {
        if (data?.autoUpdatePrices) {
          this.pricingService.turnOffCurrentOfferPricing().subscribe();
        }
      });
    }
  }
}
